export const SET_CONVERSATION_SWIPER_POSITION =
    'SET_CONVERSATION_SWIPER_POSITION';
export const CLEAR_CONVERSATION_SWIPER_POSITIONS =
    'CLEAR_CONVERSATION_SWIPER_POSITIONS';
